import BaseAccordionPanel from "@PegasusCore/pegasus-one-accordion-panel/src/script";

class AccordionPanel extends BaseAccordionPanel {
    panelID = null;
    panelOpen = false;

    constructor(panelID) {
        super();
        
        // set this.panelID to panelID with any # removed
        if (panelID) {
            panelID = panelID.replace(/#/g, "");
        }

        this.panelID = panelID;
        this.panelOpen = activeOnLoad;
    }
    
    init() {
        if (this.panelID) {
            setTimeout(() => {
                this.checkUrlHash();
            }, 100);
        }
    }
    
    checkUrlHash() {
        const url = new URL(window.location.href);
        const search = new URLSearchParams(url.search);
        const hash = search.get('panel');
        
        if (hash && this.panelID && hash === this.panelID) {
            console.log('AccordionPanel - Match found! Opening panel...');
    
            this.$nextTick(() => {
                this.panelOpen = true;
                console.log('AccordionPanel - Panel opened:', this.panelOpen);
            });
        } else {
            console.log('AccordionPanel - No match or missing data');
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("accordionPanel", (panelID, activeOnLoad = false) => ({
        panelID: panelID?.replace(/#/g, "") || null,
        panelOpen: activeOnLoad,

        init() {
            if (this.panelID) {
                setTimeout(() => {
                    const url = new URL(window.location.href);
                    const search = new URLSearchParams(url.search);
                    const hash = search.get('panel');

                    if (hash && this.panelID && hash === this.panelID) {
                        console.log('AccordionPanel - Match found! Opening panel via URL...');
                        this.panelOpen = true;
                    }
                }, 100);
            }
        }
    }));
});
